import {Card, CardActionArea, css, styled} from '@mui/material';
import Icon from 'presentation/icons';
import {ServiceCardStyleProps} from './types';

const StyledCardActionArea = styled(CardActionArea)`
	min-width: 104px;
	min-height: 60px;
	height: 100%;
	border-radius: 8px;

	${({theme}) => theme.breakpoints.down('sm')} {
		height: 52px;
	}
`;

const StyledCard = styled(Card)<ServiceCardStyleProps>`
	display: flex;
	height: 100%;
	align-items: center;
	padding: 8px 12px;
	gap: 12px;

	${({theme}) => theme.breakpoints.down('sm')} {
		gap: 8px;
	}

	${({$hasEmphasis, theme}) =>
		$hasEmphasis &&
		css`
			background-color: ${theme.palette.primary.main};
		`}
`;

const StyledIcon = styled(Icon)<ServiceCardStyleProps>`
	flex-shrink: 0;

	${({theme}) => theme.breakpoints.down('sm')} {
		width: 17px;
		height: 17px;
	}

	color: ${({$hasEmphasis, theme}) =>
		$hasEmphasis ? theme.palette.common.white : theme.palette.primary.main};
`;

export {StyledCard, StyledCardActionArea, StyledIcon};
